import styles from './ProjectTeam.module.scss';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const ProjectTeam = ({ props }) => {
  return (
    <section className={classnames(isMobile ? [styles.section, styles.mobile] : [styles.section])}>
      <h2 className={classnames(isMobile ? [styles.sectionTitle, styles.mobile] : [styles.sectionTitle])}>Команда</h2>

      <ul className={classnames(isMobile ? [styles.list, styles.mobile] : [styles.list])}>
        {props.map((item) => (
          <li className={classnames(isMobile ? [styles.item, styles.mobile] : [styles.item])} key={item.id}>
            <p className={classnames(isMobile ? [styles.fio, styles.mobile] : [styles.fio])}>{item.fio}</p>
            <p className={styles.position}>{item.position}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProjectTeam;
